<template>
  <div class="centerBox">
    <div class="isDetailNot" v-if="loading">
      <div
        :class="{
          BoxHead: $store.state.isLogin == 1,
          BoxHead2: $store.state.isLogin != 1,
        }"
      >
        <div class="headLeft">
          <!-- 返回按钮 -->
          <div class="leftJt" @click="toBack">
            <svg-btn class="leftIcon" icon-class="icon-left"></svg-btn>
          </div>
          <!-- logo -->
          <div class="skeleton-avatar"></div>
          <!-- 用户信息 -->
          <div class="info">
            <div class="skeleton-name"></div>
            <div class="skeleton-fans"></div>
          </div>
        </div>
        <div class="headright" v-show="arrDetail.is_follow != -1">
          <div class="skeleton-bt"></div>
          <div class="moreBox">
            <svg-btn class="more" icon-class="icon-gfans-more"></svg-btn>
          </div>
        </div>
      </div>
      <!-- 主体内容 -->
      <div class="content">
        <!-- 标题 -->
        <div class="skeleton-title"></div>
        <!-- 时间和关联标签 -->
        <div class="timeTabBox">
          <div class="skeleton-time"></div>
          <div class="skeleton-time"></div>
          <div class="skeleton-time"></div>
        </div>
        <div class="skeleton-html"></div>
        <div class="naturalBox">
          <div class="natural" v-for="(item, index) in 4" :key="index">
            <div class="leftBox">
              <!-- 资源图标 -->
              <div class="skeleton-leftIcon"></div>
              <div class="rightInfo">
                <!-- 资源名称和按钮 -->
                <div class="skeleton-text1"></div>
                <div class="skeleton-text2"></div>
              </div>
            </div>
            <div class="skeleton-rightBt"></div>
          </div>
        </div>
      </div>
      <!-- 评论内容 -->
      <div class="comment" style="padding-bottom: 0">
        <!-- 评论头部 -->
        <div class="commentHead">
          <div class="headLeft">
            <div class="skeleton-cfont1"></div>
          </div>
          <div class="headRight">
            <div class="skeleton-cfont1"></div>
            <div class="skeleton-cfont1"></div>
          </div>
        </div>
        <!-- 评论输入框 -->
        <div class="commitInputBox">
          <div class="leftInput">
            <div class="skeleton-headImg"></div>
          </div>
          <div class="skeleton-Input"></div>
          <div class="skeleton-bt2"></div>
        </div>
        <!-- 空状态 -->
        <div class="noneData">
          <div class="skeleton-noneIcon"></div>
          <div class="skeleton-font2"></div>
        </div>
      </div>
      <!-- 底部悬浮按钮 -->
      <div class="bottomBox">
        <!-- 分享按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-share"></svg-btn>
        </div>
        <!-- 点赞按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-up"></svg-btn>
        </div>
        <!-- 收藏按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-collect"></svg-btn>
        </div>
        <!-- 评论按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-comment"></svg-btn>
        </div>
      </div>
    </div>
    <!-- 无论是站点维护还是帖子不见了都走这个notFound -->
    <notFound v-if="!loading && isNot" title="帖子"></notFound>
    <div v-if="!loading && !isNot" class="isDetail">
      <!-- 悬浮头部 -->
      <div
        :class="{
          BoxHead: $store.state.isLogin == 1,
          BoxHead2: $store.state.isLogin != 1,
        }"
      >
        <div class="headLeft">
          <!-- 返回按钮 -->
          <div class="leftJt" @click="toBack">
            <svg-btn class="leftIcon" icon-class="icon-left"></svg-btn>
          </div>
          <!-- logo -->
          <el-image
            @click="toUser(arrDetail)"
            :src="arrDetail.logo"
            fit="cover"
            class="headImg"
          >
            <img
              width="48"
              height="48"
              slot="error"
              class="error-headImg"
              @click="toUser(arrDetail)"
              :src="$utils.getPng('icon-gfans-defaultHead')"
            />
          </el-image>
          <!-- 用户信息 -->
          <div class="info">
            <div class="font1" @click="toUser(arrDetail)">
              {{ arrDetail.nickname }}
            </div>
            <div class="font2">{{ arrDetail.fans }}订阅</div>
          </div>
        </div>
        <div class="headright" v-show="arrDetail.is_follow != -1">
          <div
            @click="checkDy()"
            :class="{
              releaseBtn: true,
              primaryBtn: arrDetail.is_follow == 0,
              releaseBtn2: arrDetail.is_follow == 1,
              textBtn: arrDetail.is_follow == 1,
            }"
          >
            {{ arrDetail.is_follow == 1 ? '已订阅' : '订阅' }}
          </div>
          <ClickPop class="ClickPop">
            <div class="moreBox">
              <svg-btn class="more" icon-class="icon-gfans-more"></svg-btn>
            </div>
            <div slot="content" class="arrCheck">
              <div
                class="check"
                @click="checkTip(item)"
                v-for="(item, index) in arrDetail.is_follow == 1
                  ? checkList
                  : checkList2"
                :key="index"
              >
                <svg-btn
                  class="moreIcon"
                  :icon-class="'icon-gfans-more' + item.id"
                ></svg-btn>
                <span class="font3">{{ item.name }}</span>
              </div>
            </div>
          </ClickPop>
        </div>
      </div>
      <!-- 主体内容 -->
      <div class="content">
        <!-- 标题 -->
        <div class="title">
          {{ arrDetail.name }}
        </div>
        <!-- 时间和关联标签 -->
        <div class="timeTabBox">
          <div class="time">{{ arrDetail.in_time }}</div>
          <div class="tabBox">
            <div
              class="tab"
              @click="toTab(item)"
              v-for="(item, index) in arrDetail.tag_title"
              :key="index"
            >
              <span class="tabFont">{{ item.name }}</span>
            </div>
          </div>
        </div>
        <!-- 文章贴内容-->
        <div
          class="htmlBox"
          v-show="ptype == 200"
          v-html="arrDetail.vhtml"
          @click="handleImgClick"
        ></div>
        <!-- 图文贴内容 -->
        <div class="imgHtmlBox" v-show="ptype == 33">
          <!-- 图文贴预览图片需要展开全文后才可以 -->
          <div
            v-if="isMore"
            class="htmlBox"
            v-html="html"
            @click="handleImgClick"
          ></div>
          <div v-if="!isMore" class="htmlBox" v-html="arrDetail.vhtml"></div>
          <div class="clickMore" v-if="!isMore">
            <div class="morea" @click="getMore">点击展开全文</div>
            <svg-btn
              @click="getMore"
              class="bottomIcon"
              icon-class="icon-gfans-bottom"
            ></svg-btn>
          </div>
        </div>

        <!-- 资源贴内容 全是图片-->
        <div v-show="ptype != 200 && ptype != 33" class="imgBox">
          <el-image
            v-for="(item, index) in arrDetail.imgs"
            @click="handleImgClick"
            :key="index"
            :src="item"
            fit="cover"
            class="img"
            lazy
          >
            <template #error>
              <img
                style="margin-bottom: 0"
                :src="
                  $utils.getPng(
                    $store.state.theme == 'light'
                      ? 'icon-gfans-deimg'
                      : 'icon-gfans-deimg-dark'
                  )
                "
                alt=""
                class="img"
              />
            </template>
          </el-image>
        </div>

        <!-- 资源 -->
        <div
          class="naturalBox"
          v-show="
            arrDetail.file_attachment && arrDetail.file_attachment.length > 0
          "
        >
          <div
            class="natural"
            v-for="(item, index) in arrDetail.file_attachment"
            :key="index"
          >
            <div class="leftBox">
              <!-- 资源图标 -->
              <svg-btn
                class="leftIcon"
                :icon-class="getFileIcon(item.stype)"
              ></svg-btn>
              <div class="rightInfo">
                <!-- 资源名称和按钮 -->
                <div class="text1">{{ item.name }}</div>
                <div v-show="item.file_size" class="text2">
                  {{ item.file_size }}
                </div>
              </div>
            </div>
            <div class="rightBt primaryBtn" @click="toDown(item)">
              {{ getFileBt(item.stype) }}
            </div>
          </div>
        </div>
        <!-- 下载并订阅该订阅号/查看并订阅该订阅号 如果勾选了，就在点上方资源的时候调用订阅接口-->
        <!-- show_down_follow 1-显示下载并订阅 0-不显示 -->
        <div
          class="checkBox"
          v-show="arrDetail.show_down_follow == 1 && arrDetail.is_follow == 0"
        >
          <div class="cBox" @click="checkUp">
            <svg-btn
              :class="{
                checkIcon: true,
                checkIcon2: isCheck,
              }"
              :icon-class="isCheck ? 'icon-gfans-checka' : 'icon-gfans-check'"
            ></svg-btn>
            <!-- 文章贴和资源贴 -->
            <div v-show="ptype != 33" class="checkFont">下载并订阅该订阅号</div>
            <!-- 图文贴 -->
            <div v-show="ptype == 33" class="checkFont">查看并订阅该订阅号</div>
          </div>
        </div>
      </div>
      <!-- 评论内容 -->
      <div class="comment" ref="commentBox">
        <!-- 评论头部 -->
        <div class="commentHead">
          <div class="headLeft">
            <div class="cfont1">评论</div>
            <div class="cfont2">{{ total }}</div>
          </div>
          <div class="headRight">
            <div class="oneRight" @click="lookAuthor">
              <svg-btn
                :class="{
                  oneIcon: true,
                  oneIcon2: only_author,
                }"
                :icon-class="only_author ? 'icon-authorX' : 'icon-author'"
              ></svg-btn>
              <div
                :class="{
                  cfont3: true,
                  cfont3A: only_author,
                }"
              >
                只看作者
              </div>
            </div>
            <div class="line"></div>
            <ClickPop class="ClickPop">
              <div class="twoRight">
                <svg-btn
                  class="twoIcon"
                  :icon-class="
                    sort_type == 2
                      ? 'icon-hot-new'
                      : sort_type == 1
                      ? 'icon-hot'
                      : 'icon-hot-long'
                  "
                ></svg-btn>
                <div class="cfont3">
                  {{
                    sort_type == 2 ? '最新' : sort_type == 1 ? '最热' : '最早'
                  }}
                </div>
              </div>
              <div slot="content" class="arrCheck">
                <div
                  class="check"
                  @click="checkHot(item)"
                  v-for="(item, index) in checkHotList"
                  :key="index"
                >
                  <div class="bor">
                    <svg-btn
                      class="moreIcon2"
                      :icon-class="
                        item.id == 2
                          ? 'icon-hot-new'
                          : item.id == 1
                          ? 'icon-hot'
                          : 'icon-hot-long'
                      "
                    ></svg-btn>
                    <span class="font3">{{ item.name }}</span>
                  </div>
                  <svg-btn
                    v-if="sort_type == item.id"
                    class="yesIcon"
                    icon-class="icon-yes"
                  ></svg-btn>
                </div>
              </div>
            </ClickPop>
          </div>
        </div>
        <!-- 评论输入框 -->
        <div class="commitInputBox">
          <div class="leftInput">
            <el-image
              :src="$store.state.userInfo.logo || arrDetail.def_logo"
              fit="cover"
              class="headImg"
            >
              <img
                width="48"
                height="48"
                slot="error"
                class="error-headImg"
                :src="$utils.getPng('icon-gfans-defaultHead')"
              />
            </el-image>
          </div>
          <div class="Input">
            <el-input
              :class="{
                commitInput: true,
                textInput: !commitFous && textarea.length == 0,
              }"
              type="textarea"
              resize="none"
              autosize
              maxlength="2000"
              @focus="handleFocus"
              @keydown.enter.native="handleBlur"
              @blur="handleBlur"
              :placeholder="!commitFous ? '来说点什么吧～' : ''"
              v-model="textarea"
            >
            </el-input>
            <svg-btn
              v-if="!commitFous && textarea.length == 0"
              class="inputIcon"
              icon-class="icon-input"
            ></svg-btn>
          </div>
          <div
            @click="reply()"
            :class="{
              rightInput: true,
              primaryBtn: textarea.trim().length > 0,
              primaryBtnDis: textarea.trim().length == 0,
            }"
          >
            发送
          </div>
        </div>
        <!-- 评论主体组件 -->
        <div class="commitContent" v-if="total > 0">
          <div
            class="commitBox"
            v-for="(item, index) in commitList"
            :key="index"
          >
            <div
              class="oneCommit"
              :class="{ commitBg: item.in_high_light == 1 }"
            >
              <div class="leftC">
                <el-image
                  @click="toUser(item)"
                  :src="item.logo"
                  fit="cover"
                  class="headImg"
                >
                  <img
                    width="48"
                    height="48"
                    slot="error"
                    class="error-headImg"
                    @click="toUser(item)"
                    :src="$utils.getPng('icon-gfans-defaultHead')"
                  />
                </el-image>
                <div class="rightCommit">
                  <div class="commitFont1">
                    <div class="fontLeft">
                      <span class="nickname">{{ item.nickname }}</span>
                      <!-- 会员铭牌 -->
                      <img
                        v-if="item.nameplate"
                        class="vipImg"
                        :src="item.nameplate"
                      />
                      <div class="authorTopBox" v-if="item.isauther == 1">
                        作者
                      </div>
                      <div class="authorTopBox" v-if="item.is_top_up == 1">
                        置顶
                      </div>
                    </div>
                    <ClickPop class="ClickPop" v-if="is_self == 1">
                      <div class="moreBox">
                        <svg-btn
                          class="more"
                          icon-class="icon-gfans-more"
                        ></svg-btn>
                      </div>
                      <div slot="content" class="arrCheck">
                        <div
                          class="check"
                          @click="checkMetch(one, item)"
                          v-for="(one, oneIndex) in item.is_top_up == 1
                            ? checkList5
                            : checkList4"
                          :key="oneIndex"
                        >
                          <span style="margin-left: 0" class="font3">{{
                            one.name
                          }}</span>
                        </div>
                      </div>
                    </ClickPop>
                  </div>
                  <div class="commitFont2">{{ item.comment }}</div>
                  <div class="commitFont3">
                    {{ item.in_time }}
                    <div class="commitFont4" @click="replyToComment(item, 1)">
                      回复
                    </div>
                  </div>
                </div>
              </div>
              <!-- 一级评论输入框 -->
              <div class="twoInput" v-if="replyTargetId === item.id">
                <el-input
                  class="commitInput"
                  type="textarea"
                  resize="none"
                  autosize
                  maxlength="2000"
                  @keydown.enter.native="handleBlur2"
                  @focus="handleFocus2"
                  @blur="handleBlur2"
                  :placeholder="!commitFous2 ? '回复@' + replyText : ''"
                  v-model="textarea2"
                >
                </el-input>
                <div
                  :class="{
                    rightInput: true,
                    primaryBtn: textarea2.trim().length > 0,
                    primaryBtnDis: textarea2.trim().length == 0,
                  }"
                  @click="replyChild(1)"
                >
                  发送
                </div>
              </div>
            </div>
            <div class="twoCommit">
              <!-- 二级评论 -->
              <div
                class="commitChild"
                :class="{ commitBg: itn.in_high_light == 1 }"
                v-for="(itn, idx) in item.child"
                :key="idx"
              >
                <div class="leftC">
                  <el-image
                    @click="toUser(itn)"
                    :src="itn.logo"
                    fit="cover"
                    class="childImg"
                  >
                    <img
                      width="34"
                      height="34"
                      slot="error"
                      @click="toUser(item)"
                      class="error-headImg"
                      :src="$utils.getPng('icon-gfans-defaultHead')"
                    />
                  </el-image>
                  <div class="childCommitBox">
                    <div class="commitB">
                      <div class="commitFont4">
                        <span class="commitText">{{ itn.nickname }}</span>
                        <!-- 会员铭牌 -->
                        <img
                          class="vipImg"
                          v-if="itn.nameplate"
                          :src="itn.nameplate"
                        />
                        <div class="authorTopBox" v-if="itn.uid_is_auther == 1">
                          作者
                        </div>
                        <span class="replyFont" v-if="itn.userid != itn.touid"
                          >回复</span
                        >
                        <span
                          class="commitText"
                          v-if="itn.userid != itn.touid"
                          >{{ itn.reply_nickname }}</span
                        >
                        <!-- 会员铭牌 -->
                        <img
                          v-if="itn.reply_nameplate && itn.userid != itn.touid"
                          class="vipImg"
                          :src="itn.reply_nameplate"
                        />
                        <div
                          class="authorTopBox"
                          v-if="
                            itn.touid_is_auther == 1 && itn.userid != itn.touid
                          "
                        >
                          作者
                        </div>
                        <div class="authorTopBox" v-if="itn.is_top_up == 1">
                          置顶
                        </div>
                      </div>
                      <ClickPop class="ClickPop" v-if="is_self == 1">
                        <div class="moreBox">
                          <svg-btn
                            class="more"
                            icon-class="icon-gfans-more"
                          ></svg-btn>
                        </div>
                        <div slot="content" class="arrCheck">
                          <div
                            class="check"
                            @click="checkMetch(two, itn)"
                            v-for="(two, twoIndex) in itn.is_top_up == 1
                              ? checkList5
                              : checkList4"
                            :key="twoIndex"
                          >
                            <span style="margin-left: 0" class="font3">{{
                              two.name
                            }}</span>
                          </div>
                        </div>
                      </ClickPop>
                    </div>
                    <div class="commitFont5">{{ itn.comment }}</div>
                    <div class="commitFont6">
                      {{ itn.in_time }}
                      <div class="commitFont7" @click="replyToComment(itn, 2)">
                        回复
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 二级评论输入框 -->
                <div class="twoInput" v-if="replyTargetId === itn.id">
                  <el-input
                    class="commitInput"
                    type="textarea"
                    resize="none"
                    autosize
                    @keydown.enter.native="handleBlur2"
                    @focus="handleFocus2"
                    @blur="handleBlur2"
                    maxlength="2000"
                    :placeholder="!commitFous2 ? '回复@' + replyText : ''"
                    v-model="textarea2"
                  >
                  </el-input>
                  <div
                    :class="{
                      rightInput: true,
                      primaryBtn: textarea2.trim().length > 0,
                      primaryBtnDis: textarea2.trim().length == 0,
                    }"
                    @click="replyChild(2)"
                  >
                    发送
                  </div>
                </div>
              </div>
              <div class="twoMore" v-if="item.child_total > 0">
                <div class="twoMoreFont" @click="getMoreChild(item, index)">
                  共有 {{ item.child_total }} 条回复，点击查看
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部加载状态 -->
        <div
          class="loadStatus"
          v-if="total > 0 && (isLoading || remaining == 0)"
        >
          <div v-show="isLoading" class="loadBox">
            <div class="spinner"></div>
            <span class="not">加载中</span>
          </div>
          <div class="not" v-show="!isLoading && remaining == 0">
            暂无更多评论
          </div>
        </div>
        <!-- <div class="moreCommit" v-if="total > 0 && remaining != 0">
          <div class="more" @click="getMoreCommit">
            展开评论（{{ remaining }}）
          </div>
        </div> -->
        <!-- 空状态 -->
        <div class="noneData" v-if="total == 0">
          <img
            class="noneIcon"
            :src="
              $utils.getPng(
                $store.state.theme == 'light'
                  ? 'icon-gfans-none'
                  : 'icon-gfans-none-dark'
              )
            "
          />
          <div class="font2">暂无评论</div>
        </div>
      </div>
      <!-- 底部悬浮按钮 -->
      <div class="bottomBox">
        <!-- 分享按钮 -->
        <div class="bottom" @click="checkShare(arrDetail.share_url)">
          <svg-btn class="icon" icon-class="icon-share"></svg-btn>
          <div class="bottomFont">
            {{ $utils.formatNumber(arrDetail.share_num) }}
          </div>
        </div>
        <!-- 点赞按钮 -->
        <div class="bottom" @click="checkLikeUp">
          <svg-btn
            :class="{
              icon: true,
              icon2: arrDetail.is_like == 1,
            }"
            :icon-class="arrDetail.is_like == 1 ? 'icon-up-x' : 'icon-up'"
          ></svg-btn>
          <div
            :class="{
              bottomFont: true,
              bottomFont2: arrDetail.is_like == 1,
            }"
          >
            {{ $utils.formatNumber(arrDetail.good_num) }}
          </div>
        </div>
        <!-- 收藏按钮 -->
        <div class="bottom" @click="checkCollect">
          <svg-btn
            :class="{
              icon: true,
              icon2: arrDetail.is_collect == 1,
            }"
            :icon-class="
              arrDetail.is_collect == 1 ? 'icon-collect-x' : 'icon-collect'
            "
          ></svg-btn>
          <div
            :class="{
              bottomFont: true,
              bottomFont2: arrDetail.is_collect == 1,
            }"
          >
            {{ $utils.formatNumber(arrDetail.save_num) }}
          </div>
        </div>
        <!-- 评论按钮 -->
        <div class="bottom" @click="scrollToCommet">
          <svg-btn class="icon" icon-class="icon-comment"></svg-btn>
          <div class="bottomFont">
            {{ $utils.formatNumber(total) }}
          </div>
        </div>
      </div>
    </div>
    <!-- 隐藏的预览组件 -->
    <el-image
      ref="previewImage"
      style="display: none"
      :src="currentImage"
      :preview-src-list="imageList"
    >
    </el-image>
    <!-- 自定义预览指示器 -->
    <div v-if="previewVisible" class="imagePreview" @click.stop>
      {{ currentIndex + 1 }}/{{ imageList.length }}
    </div>
    <PromptTip
      @confirm="confirm"
      @handleClose="handleClose"
      :tips="tips"
      :isShow="isShow"
    />
    <report
      stype="1"
      :id="arrDetail.id"
      @handleClose="reportShow = false"
      :isShow="reportShow"
    />
    <!-- 非会员拦截弹窗 -->
    <VipInterceptBox
      :isShowModel="isShowModelBox"
      :btnShow="false"
      :vipTxt="vipTxt"
      @handleClose="isShowModelBox = false"
      @openVip="goVip"
    />
    <!-- 消耗弹框 -->
    <ConsumeBox
      @confirm="confirmConsume"
      @routeMode="routeModeFn"
      :showContent="showContent"
      :isShow="showConsumeBox"
      :consumeInfo="consumeInfo"
      @handleClose="showConsumeBox = false"
    />
    <!-- 绑定手机号 -->
    <Bindphone ref="bindPhone" />

    <!-- 验证手机号 -->
    <VerifyPhone
      :isShow="showVerifyPhone"
      :verifyData="verifyData"
      @handleClose="showVerifyPhone = false"
      @goNext="confirmConsume"
    />
    <Riskverification
      ref="Riskver"
      @handleClose="handleCloseRisk"
      @riskveAgain="riskveAgain"
    />
  </div>
</template>

<script>
import notFound from '@/components/notFound/index'
import ClickPop from '@/components/ClickPop/index'
import PromptTip from '@/components/PromptTip/index'
import report from '@/components/report/index'
import {
  checkModirlt,
  getDetailAPI,
  setShare,
  checkLike,
  checkCollec,
  fmDonwList,
  localDownAPI,
  getMoreInfo,
  getCommetAPI,
  checkCommetAPI,
  getCommetChildAPI,
  getCommetTopAPI,
  delCommetAPI,
} from '@/axios/home'
import { eventBus } from '@/utils/event-bus'
import VipInterceptBox from '@/components/VipInterceptBox'
import ConsumeBox from '@/components/ConsumeBox'
import Bindphone from '@/components/Bindphone.vue'
import VerifyPhone from '@/components/VerifyPhone/index.vue'
import Riskverification from '@/components/Riskverification.vue'

export default {
  components: {
    notFound,
    ClickPop,
    PromptTip,
    report,
    ConsumeBox,
    VipInterceptBox,
    Bindphone,
    VerifyPhone,
    Riskverification,
  },
  data() {
    return {
      checkList: [
        {
          id: 1,
          name: '取消订阅',
        },
        {
          id: 2,
          name: '举报',
        },
      ],
      checkList2: [
        {
          id: 2,
          name: '举报',
        },
      ],
      checkHotList: [
        {
          id: 2,
          name: '最新',
        },
        {
          id: 1,
          name: '最热',
        },
        {
          id: 3,
          name: '最早',
        },
      ],
      sort_type: 1,
      checkList4: [
        {
          id: 1,
          name: '置顶',
        },
        {
          id: 3,
          name: '删除',
        },
      ],
      checkList5: [
        {
          id: 0,
          name: '取消置顶',
        },
        {
          id: 3,
          name: '删除',
        },
      ],
      isCheck: true,
      isShow: false, //消息提示
      reportShow: false, //举报弹窗
      imageList: [], // 所有图片URL列表
      currentImage: '', // 当前点击的图片URL
      currentIndex: 0,
      previewVisible: false,
      observer: null,
      only_author: false,
      textarea: '',
      textarea2: '',
      commitFous: false,
      commitFous2: false,
      commitList: [], //评论数据list
      tips: '',
      replyTargetId: null, // 记录当前回复的目标评论ID
      replyText: '', // 回复内容
      isNot: false, //是否走到notFound
      arrDetail: {}, //帖子详情
      ptype: '', //200-文章 33-图文 其他都是资源帖
      newList: '', //最新动态
      showType: '', //dy操作订阅 pl操作评论 sc是操作收藏
      fshort: '', //fshort
      fetch_code: '', //fetch_code
      isShowModelBox: false, //非会员拦截弹窗
      vipTxt: '今日订阅号文件下载次数已用尽，请升级会员进行体验',
      sc: '', //屏幕点击位置
      ms: '', //屏幕点击位置
      showContent: 2,
      showConsumeBox: false,
      consumeInfo: {
        title: '',
        content: '',
        vip_update: 1, //是否可以升级会员1是0否
      }, //消耗信息
      confirmLine: 0, //是否确认消耗
      showVerifyPhone: false,
      verifyData: {
        pcode: '+86', //区号
        phone: '', //手机号码
      },
      accessid: '',
      isMore: false, //是否查看全文
      html: '', //查看全文的html
      page: 1, //评论页码
      with_cthis: '', //关联评论ID
      is_self: 0, //0不是自己的评论 1才是
      total: null, //评论总数
      remaining: null, //剩余一级评论数
      level: 0, //直接评论传递0 回复传1
      pid: '', //上级评论ID
      touid: '', //回复用户ID
      isLoading: false,
      comment_type: '', //操作类型
      comment_id: '', //评论id
      loading: false,
      isType: '', //2从我的订阅来 3从个人主页来 else返回首页
      is_with_com_id: 0, //后端需要参数，他传过来，前端传过去
      isMobile: false,
      down_num: 0, //0就表示没有下载过，需要弹窗
    }
  },
  created() {
    //初始化数据
    this.fetchData()
    this.updateMobileStatus() // 初始检查
  },
  mounted() {
    // 监听头部退出登录
    eventBus.$on('upDetailList', num => {
      //初始化数据
      this.cleanupObserver()
      // 清理定时器
      if (this.previewWatcher) {
        clearInterval(this.previewWatcher)
      }
      this.with_cthis = ''
      this.page = 1
      this.isLoading = false
      this.fetchData()
    })
    window.addEventListener('scroll', this.handleScroll)
    // 监听窗口尺寸变化
    window.addEventListener('resize', this.updateMobileStatus)
    //从消息过来的
    if (this.$route.query.with_cthis) {
      this.with_cthis = this.$route.query.with_cthis
    }
    if (this.$route.query.isType) {
      this.isType = this.$route.query.isType
    }
    this.$router.replace({
      name: 'jx',
      params: this.$route.params,
      query: {}, // 清空 query
    })
  },
  beforeDestroy() {
    eventBus.$off('upDetailList')
    // 移除事件监听器以避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.updateMobileStatus)
    this.cleanupObserver()
    // 清理定时器
    if (this.previewWatcher) {
      clearInterval(this.previewWatcher)
    }
  },
  watch: {
    currentImage() {
      this.updateCurrentIndex()
    },
    previewVisible(val) {
      if (!val && this.previewWatcher) {
        clearInterval(this.previewWatcher)
      }
    },
    '$route.params.id'() {
      this.cleanupObserver()
      // 清理定时器
      if (this.previewWatcher) {
        clearInterval(this.previewWatcher)
      }
      this.with_cthis = ''
      this.page = 1
      this.isLoading = false
      this.scrollToTop()
      this.fetchData()
    },
  },
  methods: {
    //初始化数据
    async fetchData() {
      this.loading = true
      try {
        let res = await getDetailAPI({
          code: this.$route.params.id,
          stype: 1, //	1-文章 2-视频
          theme: this.$store.state.theme,
        })
        if (res.status == 1) {
          document.title = res.data.name + ' - Gfans'
          this.arrDetail = res.data
          this.arrDetail.vhtml = this.arrDetail.vhtml
            .replace(/<(?!\/?(img|font|p|div)|[! ])[^>]*>/g, '')
            .replace(
              /<font([^>]*)\ssize\s*=\s*["'][^"']*["']([^>]*)>/gi,
              '<font$1$2>'
            )
          this.down_num = res.data.down_num
          this.ptype = res.data.ptype
          this.newList = res.data.news_post
          this.extractImageUrls()
          //获取评论数据
          await this.getCommetLis()
        } else if (res.status == 402001) {
          // 站点维护或者帖子不见
          this.loading = false
          this.isLoading = false
          this.isNot = true
        } else {
          this.$toast(res.msg, 2)
        }
      } catch (error) {}
    },
    //获取评论数据
    async getCommetLis() {
      if (this.isLoading) return
      this.isLoading = true
      try {
        let data = {
          type: 1,
          id: this.arrDetail.id,
          sort_type: this.sort_type,
          page: this.page,
          only_author: this.only_author,
          with_com_id:
            this.with_cthis == -1 || this.with_cthis == ''
              ? ''
              : this.with_cthis, //关联评论ID
          is_with_com_id: this.is_with_com_id,
        }
        let res = await getCommetAPI(data)
        if (res.status == 1) {
          // 去重逻辑：过滤掉已存在于 commitList 中的评论
          const newList = res.data.list.filter(
            newItem =>
              !this.commitList.some(
                existingItem => existingItem.id == newItem.id
              )
          )
          this.commitList =
            this.page == 1
              ? [...res.data.list] // 首页直接赋值
              : [...this.commitList, ...newList] // 后续页追加数据
          this.is_self = res.data.is_self
          this.total = Number(res.data.total)
          this.remaining = Number(res.data.remaining)
          this.is_with_com_id = res.data.is_with_com_id
          eventBus.$emit('upNewList', this.newList)
          this.loading = false
          this.isLoading = false
          if (this.with_cthis) {
            this.$nextTick(() => {
              this.scrollToCommet()
            })
          }
        } else {
          this.$toast(res.msg, 2)
        }
      } catch (error) {}
    },
    //获取子级评论数据
    async getMoreChild(item, index) {
      try {
        let data = {
          type: 1, //1-文章 2-视频
          id: item.id, //评论ID
          page: item.page, //页数
          only_author: this.only_author, //是否只看作者 1-是 0-否
        }
        let res = await getCommetChildAPI(data)
        if (res.status == 1) {
          // 去重逻辑：过滤掉已存在于 commitList 中的评论
          const newList = res.data.list.filter(
            newItem =>
              !this.commitList[index].child.some(
                existingItem => existingItem.id == newItem.id
              )
          )
          if (item.page == 1) {
            this.commitList[index].child.push(...res.data.list)
          } else {
            this.commitList[index].child.push(...newList)
          }
          this.commitList[index].child_total = res.data.remaining
          this.commitList[index].page++
        } else {
          this.$toast(res.msg, 2)
        }
      } catch (error) {}
    },
    // 滚动处理方法
    handleScroll() {
      // 如果正在加载、没有更多评论、或者当前不是详情页，则返回
      if (this.isLoading || this.remaining <= 0 || this.loading || this.isNot) {
        return
      }

      // 计算滚动位置
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = window.innerHeight
      const scrollHeight = document.documentElement.scrollHeight

      // 当滚动到底部100px范围内时触发加载
      if (scrollTop + windowHeight >= scrollHeight - 100) {
        this.getMoreCommit()
      }
    },
    //跳转个人中心
    toUser: _.debounce(
      function (item) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        const route = this.$router.resolve({
          name: 'user',
          params: { uid: item.uid },
        })
        // 使用解析后的 href 打开新窗口
        window.open(route.href, '_blank')
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //查看标签页
    toTab(item) {
      const route = this.$router.resolve({
        name: 'tab',
        params: { id: item.only_code },
      })
      window.open(route.href, '_blank')
    },
    //获取资源图标
    getFileIcon(stype) {
      //1是文件 2是合计 3是资源 4是帖子
      let num = Number(stype)
      switch (num) {
        case 1:
          return 'icon-gfans-wj'
        case 2:
          return 'icon-gfans-hj'
        case 3:
          return 'icon-gfans-fj'
        case 4:
          return 'icon-gfans-fj'
        default:
          return
      }
    },
    //获取资源按钮名称
    getFileBt(stype) {
      let num = Number(stype)
      switch (num) {
        case 1:
          return 'Feemoo下载'
        case 2:
          return '去查看'
        case 3:
          return '文件下载'
        case 4:
          return '查看帖子'
        default:
          return
      }
    },
    updateMobileStatus() {
      const ua = navigator.userAgent
      // 原有的移动设备检测逻辑
      const isMobileByUA =
        (!/(iPad).*OS\s([\d_]+)/.test(ua) &&
          /(iPhone\sOS)\s([\d_]+)/.test(ua)) ||
        /(Android)\s+([\d.]+)/.test(ua)

      // 使用两者的组合判断（根据你的需求调整）
      this.isMobile = isMobileByUA
    },
    //点击资源
    toDown: _.debounce(
      function (item) {
        // if (this.$store.state.isLogin == 0) {
        //   eventBus.$emit('showLogin', {})
        //   return
        // }
        // 当isMode为Hide且item.stype为1或2时，跳过登录检查
        if (!(this.isMobile && (item.stype == 1 || item.stype == 2))) {
          if (this.$store.state.isLogin == 0) {
            eventBus.$emit('showLogin', {})
            return
          }
        }
        this.ms = window.event.clientX + '*' + window.event.clientY
        this.sc = window.screen.width + '*' + window.screen.height
        let num = Number(item.stype)
        this.fshort = item.fshort
        this.fetch_code = item.fetch_code
        switch (num) {
          case 1:
            //feemoo下载
            this.fmDonw()
            break
          case 2:
            // 去查看
            this.fmLook()
            break
          case 3:
            // 本地下载
            if (this.down_num == 0) {
              this.showContent = 3
              this.consumeInfo.content = '确认每日首次免福利点 下载此文件？'
              this.showConsumeBox = true
            } else {
              this.localDonw()
            }
            break
          case 4:
            // 查看帖子 只有视频帖才有
            this.fmVideo()
            break
          default:
            break
        }
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // feemoo下载
    fmDonw(captcha_verify, validate = {}) {
      if (validate == 'close') {
        return
      }
      // 如果是移动端直接跳转
      if (this.isMobile) {
        window.open(this.$glb.feemooUrl + '/s/' + this.fshort, '_blank')
        return
      }
      fmDonwList({
        id: this.arrDetail.file_id,
        slider_type: 13,
        lot_number: validate?.lot_number || '',
        captcha_output: validate?.captcha_output || '',
        pass_token: validate?.pass_token || '',
        gen_time: validate?.gen_time || '',
      })
        .then(res => {
          if (res.status == 1) {
            this.$reporte.setReporteThree(144)
            this.$reporte.setReporte(1, this.arrDetail.file_id, 1, this.fshort)
            //如果没有订阅该预定号，并且勾选了，执行订阅方法
            if (
              this.arrDetail.is_follow == 0 &&
              this.isCheck &&
              this.$store.state.isLogin == 1
            ) {
              this.checkDy()
            }
            window.open(this.$glb.feemooUrl + '/s/' + this.fshort, '_blank')
          } else if (res.status == 90001) {
            //极验滑块
            this.$utils.initgt4('f2cb99355c3c1db93ab5720217f697d8', this.fmDonw)
          } else if (res.status == '41003') {
            //抱歉，您今日订阅号文件下载次数已用完，请升级会员进行体验。
            // this.vipTxt = res.msg
            this.isShowModelBox = true
          } else {
            this.$toast(res.msg, 2)
          }
        })
        .catch(e => {})
    },
    // 去查看
    fmLook() {
      this.$reporte.setReporteTwo('C/1-5-10-027')
      this.$reporte.setReporte(1, this.arrDetail.file_id, 2, this.fshort)
      //如果没有订阅该预定号，并且勾选了，执行订阅方法
      if (
        this.arrDetail.is_follow == 0 &&
        this.isCheck &&
        this.$store.state.isLogin == 1
      ) {
        this.checkDy()
      }
      const { href } = this.$router.resolve({
        path: `/g/${this.fshort}`,
        query: {
          pucode: this.fetch_code,
        },
      })
      window.open(this.$glb.feemooUrl + href + '&isFromDetail=1', '_blank')
    },
    // 本地下载
    localDonw(captcha_verify, validate = {}) {
      if (validate == 'close') {
        return
      }
      localDownAPI({
        id: this.arrDetail.file_id,
        slider_type: 13,
        ms: this.ms,
        sc: this.sc,
        accessid: this.accessid,
        color: this.$store.state.theme == 'light' ? '#05d8c4' : '#06b8a7',
        confirm: this.confirmLine,
        lot_number: validate?.lot_number || '',
        captcha_output: validate?.captcha_output || '',
        pass_token: validate?.pass_token || '',
        gen_time: validate?.gen_time || '',
      })
        .then(res => {
          if (res.status == 1) {
            this.confirmLine = 0
            this.showConsumeBox = false
            this.accessid = ''
            if (res.data.accessid) {
              this.accessid = res.data.accessid
            }
            let fileName = `${res.data.name}` + `.${res.data.extension}`
            //如果没有订阅该预定号，并且勾选了，执行订阅方法
            if (
              this.arrDetail.is_follow == 0 &&
              this.isCheck &&
              this.$store.state.isLogin == 1
            ) {
              this.checkDy()
            }
            this.$store.commit('getDownloadFile', {
              name: 'query',
              value: {
                fid: this.arrDetail.id,
                fileName: fileName,
                fileType: this.arrDetail.ext,
                fileSize: this.arrDetail.origin_size,
                url: res.data.downloadUrl,
                title: '文件下载',
                type: 'jx',
              },
            })
          } else if (res.status == 90001) {
            //极验滑块
            this.$utils.initgt4(
              'f2cb99355c3c1db93ab5720217f697d8',
              this.localDonw
            )
          } else if (res.status == 68001 || res.status == 68002) {
            //非会员弹68001
            //会员弹68002
            //消耗弹窗
            this.showContent = 3
            this.consumeInfo = res.data
            this.showConsumeBox = true
          } else if (res.status == 41003) {
            //下载额度用完了
            this.isShowModelBox = true
          } else if (res.status == 81001) {
            //福利点不足
            this.showContent = 2
            this.consumeInfo = res.data
            this.showConsumeBox = true
          } else if (res.status == 40001) {
            //绑定手机号
            this.$nextTick(() => {
              this.$refs.bindPhone.setVisible()
            })
          } else if (res.status == 90200) {
            //需要验证手机号
            this.showVerifyPhone = true
            this.verifyData.pcode = res.data.pcode
            this.verifyData.phone = res.data.phone
          } else if (res.status == 90101) {
            //安全风险验证
            this.$nextTick(() => {
              this.$refs.Riskver.open()
            })
          } else {
            this.$toast(res.msg, 2)
          }
        })
        .catch(() => {})
    },
    //查看帖子
    fmVideo() {
      videolog({ vid: this.arrDetail.vid, type: 5 }).then(res => {})
      window.open(`/jx/${this.fshort}`, '_blank')
    },
    //点击展开全文
    getMore: _.debounce(
      function (captcha_verify, validate = {}) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        if (validate == 'close') {
          return
        }
        this.ms = window.event.clientX + '*' + window.event.clientY
        this.sc = window.screen.width + '*' + window.screen.height
        getMoreInfo({
          id: this.arrDetail.file_id,
          slider_type: 13,
          ms: this.ms,
          sc: this.sc,
          accessid: this.accessid,
          color: this.$store.state.theme == 'light' ? '#05d8c4' : '#06b8a7',
          confirm: this.confirmLine,
          lot_number: validate?.lot_number || '',
          captcha_output: validate?.captcha_output || '',
          pass_token: validate?.pass_token || '',
          gen_time: validate?.gen_time || '',
        }).then(res => {
          if (res.status == 1) {
            this.confirmLine = 0
            this.showConsumeBox = false
            this.accessid = ''
            if (res.data.accessid) {
              this.accessid = res.data.accessid
            }
            //如果没有订阅该预定号，并且勾选了，执行订阅方法
            if (
              this.arrDetail.is_follow == 0 &&
              this.isCheck &&
              this.$store.state.isLogin == 1
            ) {
              this.checkDy()
            }
            this.isMore = true
            this.html = res.data.vhtml
              .replace(/<(?!\/?(img|font|p|div)|[! ])[^>]*>/g, '')
              .replace(
                /<font([^>]*)\ssize\s*=\s*["'][^"']*["']([^>]*)>/gi,
                '<font$1$2>'
              )
            this.showConsumeBox = false
            //获取到新的html后需要更新图片容器
            this.extractImageUrls()
          } else if (res.status == 90001) {
            //极验滑块
            this.$utils.initgt4(
              'f2cb99355c3c1db93ab5720217f697d8',
              this.localDonw
            )
          } else if (res.status == 68001 || res.status == 68002) {
            //非会员弹68001
            //会员弹68002
            //消耗弹窗
            this.showContent = 3
            this.consumeInfo = res.data
            this.showConsumeBox = true
          } else if (res.status == 41003) {
            //下载额度用完了
            this.isShowModelBox = true
          } else if (res.status == 81001) {
            //福利点不足
            this.showContent = 2
            this.consumeInfo = res.data
            this.showConsumeBox = true
          } else if (res.status == 40001) {
            //绑定手机号
            this.$nextTick(() => {
              this.$refs.bindPhone.setVisible()
            })
          } else if (res.status == 90200) {
            //需要验证手机号
            this.showVerifyPhone = true
            this.verifyData.pcode = res.data.pcode
            this.verifyData.phone = res.data.phone
          } else if (res.status == 90101) {
            //安全风险验证
            this.$nextTick(() => {
              this.$refs.Riskver.open()
            })
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),

    //安全验证回调
    riskveAgain(accessid) {
      this.accessid = accessid
      this.confirmConsume()
    },
    //关闭安全验证
    handleCloseRisk() {
      this.showConsumeBox = false
    },
    //无用方法 老订阅号前台直接没有这个方法
    routeModeFn() {},
    //消耗确认
    confirmConsume() {
      this.down_num = 1
      this.confirmLine = 1
      //图文贴
      if (this.ptype == 33) {
        this.getMore()
      } else {
        //资源本地下载
        this.localDonw()
      }
    },
    // 去会员页
    goVip() {
      window.open(this.$glb.feemooUrl + '/vip')
    },
    // 回到顶部
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    // 定位到评论区
    scrollToCommet() {
      const commentBox = this.$refs.commentBox
      if (!commentBox) return

      requestAnimationFrame(() => {
        const rect = commentBox.getBoundingClientRect()
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop
        const targetTop = scrollTop + rect.top - 72 // 72px为导航栏高度

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: 'smooth',
        })
      })
      this.with_cthis = ''
    },
    //展开评论
    getMoreCommit() {
      this.page++
      this.getCommetLis()
    },
    //评论帖子 评论新增一级
    reply: _.debounce(
      function () {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        if (!this.textarea.trim()) return
        this.level = 0
        this.pid = ''
        this.touid = ''
        this.comment = this.textarea
        this.checkComment(1)
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //回复评论
    replyChild: _.debounce(
      function (row) {
        if (!this.textarea2.trim()) return
        this.comment = this.textarea2
        this.checkComment(2)
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // 点击回复
    replyToComment(row, index) {
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      this.textarea2 = ''
      this.replyTargetId = row.id
      this.replyText = row.nickname

      this.level = 1
      if (index == 1) {
        //回复一级评论
        this.pid = row.id
      } else {
        //回复二级评论
        this.pid = row.pid
      }
      this.touid = row.userid
    },
    //评论
    checkComment: _.debounce(
      function (row) {
        let data = {
          type: 1,
          post_id: this.arrDetail.id,
          level: this.level,
          pid: this.pid,
          touid: this.touid,
          comment: this.comment, //评论内容
        }
        checkCommetAPI(data)
          .then(res => {
            if (res.status == 1) {
              //刷新接口
              // this.getCommetLis()

              //前端判断
              if (row == 1) {
                //如果是评论一级 直接往前面加
                this.commitList.unshift(res.data)
              } else {
                //回复评论 要往后面加
                let index = this.commitList.findIndex(
                  item => item.id == this.pid
                )
                if (index != -1) {
                  this.commitList[index].child.unshift(res.data)
                }
              }
              this.total = Number(res.data.total)
              this.updateHomePage({
                comment_num: this.total,
              })
              // this.arrDetail.comment_num = this.total
              //清理评论参数
              this.clearCommit()
              this.$toast(res.msg, 1)
            } else {
              this.$toast(res.msg, 2)
            }
          })
          .catch(e => {})
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //清理评论参数
    clearCommit() {
      this.level = 0
      this.pid = ''
      this.touid = ''
      this.comment = ''
      this.textarea = ''
      this.textarea2 = ''
      this.replyTargetId = null
    },
    handleFocus() {
      this.commitFous = true
    },
    handleBlur() {
      this.commitFous = false
    },
    handleFocus2() {
      this.commitFous2 = true
    },
    handleBlur2() {
      this.commitFous2 = false
    },
    //只看作者
    lookAuthor: _.debounce(
      function () {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        this.page = 1
        this.only_author = !this.only_author
        this.getCommetLis()
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //切换type 最新最热最早
    checkHot: _.debounce(
      function (item) {
        if (this.sort_type == item.id) {
          return
        }
        this.page = 1
        this.sort_type = item.id
        this.getCommetLis()
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // 提取图片URL
    extractImageUrls() {
      if (this.ptype == 200) {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = this.arrDetail.vhtml
        const images = tempDiv.querySelectorAll('img')
        this.imageList = Array.from(images).map(img => img.src)
      } else if (this.ptype == 33) {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = this.html
        const images = tempDiv.querySelectorAll('img')
        this.imageList = Array.from(images).map(img => img.src)
      } else {
        this.imageList = this.arrDetail.imgs
      }
    },
    // 处理图片点击事件
    handleImgClick(event) {
      // if (this.$store.state.isLogin == 0) {
      //   eventBus.$emit('showLogin', {})
      //   return
      // }
      //图文贴预览图片需要展开全文后才可以
      if (event.target.tagName === 'IMG') {
        this.currentImage = event.target.src
        this.currentIndex = this.imageList.indexOf(this.currentImage)
        // 等待DOM更新后触发预览
        this.$nextTick(() => {
          if (this.$refs.previewImage) {
            // 触发Element UI的预览功能
            this.previewVisible = true
            this.$refs.previewImage.clickHandler()
            //监听是否关闭了预览
            this.handlePreview()
            this.startPreviewWatcher()
          }
        })
      }
    },
    //图片观察器
    handlePreview() {
      // 先清理之前的observer
      this.cleanupObserver()
      this.$nextTick(() => {
        const viewer = document.querySelector('.el-image-viewer__wrapper')
        if (viewer) {
          this.observer = new MutationObserver(mutations => {
            if (!document.querySelector('.el-image-viewer__wrapper')) {
              //监听到关闭了
              this.previewVisible = false
              this.cleanupObserver()
            }
          })
          this.observer.observe(viewer.parentNode, {
            childList: true,
            subtree: false,
          })
        }
      })
    },
    //清除监听器
    cleanupObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
      if (this.previewWatcher) {
        clearInterval(this.previewWatcher)
      }
    },
    //监听切换到哪张图片了
    startPreviewWatcher() {
      this.previewWatcher = setInterval(() => {
        if (!this.previewVisible) {
          clearInterval(this.previewWatcher)
          return
        }

        const activeImage = document.querySelector('.el-image-viewer__img')
        if (activeImage && activeImage.src !== this.currentImage) {
          this.currentImage = activeImage.src
        }
      }, 100)
    },
    //更新图片的下标
    updateCurrentIndex() {
      const index = this.imageList.indexOf(this.currentImage)
      if (index !== -1) {
        this.currentIndex = index
      }
    },
    //分享
    checkShare: _.debounce(
      function (str) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        setShare({ id: this.arrDetail.id, stype: 1 }).then(res => {
          if (res.status == 1) {
            //只有满足这个条件的时候，前端才自动+1
            if (res.data.num == 1) {
              this.arrDetail.share_num++
            }
            this.$copyText(str).then(
              () => {
                this.$toast('已复制分享链接到剪贴板，快去分享吧', 1)
              },
              () => {
                this.$toast('复制失败', 2)
              }
            )
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //点赞
    checkLikeUp: _.debounce(
      function () {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        let data = {
          id: this.arrDetail.file_id,
          type: 1,
          is_like: this.arrDetail.is_like == 0 ? 1 : 0,
        }
        checkLike(data).then(res => {
          if (res.status == 1) {
            this.arrDetail.is_like = this.$utils.checkNum(
              this.arrDetail.is_like
            )
            if (this.arrDetail.is_like == 1) {
              this.arrDetail.good_num++
            } else {
              if (this.arrDetail.good_num > 0) {
                this.arrDetail.good_num--
              }
            }
            this.updateHomePage({
              is_like: this.arrDetail.is_like,
              good_num: this.arrDetail.good_num,
            })
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //收藏
    checkCollect: _.debounce(
      function () {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        if (this.arrDetail.is_collect == 1) {
          this.showType = 'sc'
          this.tips = '确定取消收藏该帖子？'
          this.isShow = true
          return
        }
        checkCollec({
          type: 1,
          is_collect: 1,
          post_id: this.arrDetail.file_id,
        }).then(res => {
          if (res.status == 1) {
            this.arrDetail.is_collect = this.$utils.checkNum(
              this.arrDetail.is_collect
            )
            this.arrDetail.save_num++
            this.updateHomePage({
              is_collect: this.arrDetail.is_collect,
              save_num: this.arrDetail.save_num,
            })
            this.$toast('收藏成功', 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //切换下载并订阅该订阅号
    checkUp() {
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      this.isCheck = !this.isCheck
    },
    //返回首页发现
    toBack() {
      if (this.isType == 2 || this.isType == 3) {
        this.$router.back()
      } else {
        this.$router.push('/discover')
      }
    },
    //取消订阅 删除评论 置顶/取消置顶
    confirm: _.debounce(
      function () {
        if (this.showType == 'dy') {
          //取消订阅
          this.confirmDy()
        } else if (this.showType == 'sc') {
          //取消收藏
          this.confirmSc()
        } else if (this.showType == 'pl') {
          //删除评论
          this.confirmPl()
        } else if (this.showType == 'top') {
          //置顶评论
          this.confirmTop()
        } else {
          //极限情况，直接关闭弹窗
          this.handleClose()
        }
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //弹窗置顶方法
    confirmTop() {
      getCommetTopAPI({
        type: 1, //1-文章 2-视频
        is_top: this.comment_type, //1-置顶 0-取消置顶
        comment_id: this.comment_id, //评论ID
      })
        .then(res => {
          if (res.status == 1) {
            this.page = 1
            this.getCommetLis()
            this.handleClose()
          } else {
            this.$toast(res.msg, 2)
          }
        })
        .catch(e => {})
    },
    //弹窗取消订阅方法
    confirmDy() {
      checkModirlt({
        uid: this.arrDetail.uid,
        act: 2,
      }).then(res => {
        if (res.status == 1) {
          this.arrDetail.is_follow = this.$utils.checkNum(
            this.arrDetail.is_follow
          )
          this.arrDetail.fans--
          eventBus.$emit('upHotList')
          this.updateHomePage({
            is_follow: this.arrDetail.is_follow,
            fans: this.arrDetail.fans,
          })
          this.handleClose()
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    //弹窗取消收藏方法
    confirmSc() {
      checkCollec({
        type: 1,
        is_collect: 0,
        post_id: this.arrDetail.file_id,
      }).then(res => {
        if (res.status == 1) {
          this.arrDetail.is_collect = this.$utils.checkNum(
            this.arrDetail.is_collect
          )
          if (this.arrDetail.save_num > 0) {
            this.arrDetail.save_num--
          }
          this.updateHomePage({
            is_collect: this.arrDetail.is_collect,
            save_num: this.arrDetail.save_num,
          })
          this.handleClose()
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    //弹窗删除评论方法
    confirmPl() {
      delCommetAPI({
        type: 1, //1-文章 2-视频
        comment_id: this.comment_id, //评论ID
      })
        .then(res => {
          if (res.status == 1) {
            this.page = 1
            this.getCommetLis()
            this.handleClose()
          } else {
            this.$toast(res.msg, 2)
          }
        })
        .catch(e => {})
    },
    //点击订阅
    checkDy: _.debounce(
      function () {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        if (this.arrDetail.is_follow == 1) {
          this.showType = 'dy'
          this.tips = '确认取消订阅该订阅号？'
          this.isShow = true
          return
        }
        let data = {
          uid: this.arrDetail.uid,
          act: 1,
        }
        checkModirlt(data).then(res => {
          if (res.status == 1) {
            this.arrDetail.is_follow = this.$utils.checkNum(
              this.arrDetail.is_follow
            )
            this.arrDetail.fans++
            eventBus.$emit('upHotList')
            this.updateHomePage({
              is_follow: this.arrDetail.is_follow,
              fans: this.arrDetail.fans,
            })
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true,
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //关闭取消订阅弹窗
    handleClose() {
      this.comment_type = ''
      this.comment_id = ''
      this.showType = ''
      this.isShow = false
    },
    //订阅和举报
    checkTip(row) {
      if (row.id == 1) {
        this.showType = 'dy'
        this.tips = '确认取消订阅该订阅号？'
        this.isShow = true
      } else {
        this.reportShow = true
      }
    },
    //置顶或删除
    checkMetch(row, item) {
      this.comment_type = row.id
      this.comment_id = item.id
      if (row.id == 1) {
        this.showType = 'top'
        this.tips = '确定置顶该评论？'
        this.isShow = true
      } else if (row.id == 0) {
        this.showType = 'top'
        this.tips = '确定取消置顶该评论？'
        this.isShow = true
      } else if (row.id == 3) {
        this.showType = 'pl'
        this.tips = '确定删除该评论？'
        this.isShow = true
      }
    },
    // 批量更新多个字段并通知返回页
    updateHomePage(updatedFields) {
      // 合并需要更新的字段
      const dataToUpdate = {
        fshort: this.$route.params.id,
        ...updatedFields,
      }

      // 发送事件通知页面更新
      eventBus.$emit('itemUpdated', dataToUpdate)
    },
  },
}
</script>

<style lang="scss" scoped>
.centerBox {
  border-radius: 16px 16px 0px 0px;
  margin-top: -72px;
  .isDetail {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .BoxHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: fixed;
    position: sticky;
    top: 0;
    z-index: 400;
    height: 72px;
    min-height: 72px;
    max-width: 600px;
    width: 100%;
    .headLeft {
      display: flex;
      align-items: center;
      margin-right: 16px;
      .avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
      }

      .headImg {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        flex-shrink: 0;
        cursor: pointer;
      }

      .info {
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        max-width: 367px;

        .font1 {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          max-width: 367px;
          min-width: 75px;
          cursor: pointer;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }

        .font2 {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .leftJt {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 12px;
        flex-shrink: 0;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
        .leftIcon {
          width: 18px;
          height: 18px;
        }
        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
    }
    .headright {
      display: flex;
      align-items: center;
      .moreBox {
        cursor: pointer;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        @include useTheme {
          color: getVar('text-color7-90969c');
        }
        .more {
          width: 16px;
          height: 16px;
        }
        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
      .releaseBtn {
        padding: 5px 23px;
        height: 32px;
        border-radius: 18px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 22px;
        margin-right: 16px;
        flex-shrink: 0;
      }
      .releaseBtn2 {
        padding: 0 !important;
        width: 74px !important;
        @include useTheme {
          color: getVar('text-color2-75787b') !important;
        }
      }
      .textBtn {
        background: transparent !important;
      }
    }
  }
  @media (max-width: 1100px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 450px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于700px时 */
  @media (max-width: 700px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 420px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于600px时 */
  @media (max-width: 600px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 350px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于550px时 */
  @media (max-width: 550px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 300px;
      max-width: 100%;
      .headImg {
        display: none;
      }
      .skeleton-avatar {
        display: none;
      }
      .info {
        margin-left: 0 !important;
      }
    }
  }
  @media (max-width: 451px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 200px;
      max-width: 100%;
      .headright {
        display: none;
        .releaseBtn {
          margin-right: 5px;
        }
      }
    }
  }
  .BoxHead2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: fixed;
    position: sticky;
    top: 0;
    z-index: 400;
    height: 72px;
    min-height: 72px;
    max-width: 600px;
    width: 100%;

    .headLeft {
      display: flex;
      align-items: center;
      margin-right: 16px;

      .avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
      }

      .headImg {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        flex-shrink: 0;
        cursor: pointer;
      }

      .info {
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        max-width: 367px;

        .font1 {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          max-width: 367px;
          min-width: 75px;
          cursor: pointer;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }

        .font2 {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          @include multiline(1);

          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }

      .leftJt {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 12px;
        flex-shrink: 0;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }

        .leftIcon {
          width: 18px;
          height: 18px;
        }

        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
    }

    .headright {
      display: flex;
      align-items: center;

      .moreBox {
        cursor: pointer;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;

        @include useTheme {
          color: getVar('text-color7-90969c');
        }

        .more {
          width: 16px;
          height: 16px;
        }

        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }

      .releaseBtn {
        padding: 5px 23px;
        height: 32px;
        border-radius: 18px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 22px;
        margin-right: 16px;
        flex-shrink: 0;
      }

      .releaseBtn2 {
        padding: 0 !important;
        width: 74px !important;

        @include useTheme {
          color: getVar('text-color2-75787b') !important;
        }
      }

      .textBtn {
        background: transparent !important;
      }
    }
  }

  @media (max-width: 1100px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 400px;
      max-width: 100%;
    }
  }

  /* 当屏幕宽度小于等于700px时 */
  @media (max-width: 700px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 320px;
      max-width: 100%;
    }
  }

  /* 当屏幕宽度小于等于600px时 */
  @media (max-width: 600px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 300px;
      max-width: 100%;
    }
  }

  /* 当屏幕宽度小于等于550px时 */
  @media (max-width: 550px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 150px;
      max-width: 100%;
      .headImg {
        display: none;
      }
      .skeleton-avatar {
        display: none;
      }
      .info {
        margin-left: 0 !important;
      }
      .headright {
        display: none;
        .releaseBtn {
          margin-right: 5px;
        }
      }
    }
  }

  @media (max-width: 451px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 150px;
      max-width: 100%;
    }
  }
  .content {
    padding: 16px 16px 32px 16px;
    border-radius: 16px 16px 0px 0px;
    @include useTheme {
      background: getVar('bg-color-content');
      box-shadow: inset 0px -1px 0px 0px getVar('border-color2-f2f4f6');
    }
    .title {
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 14px;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }
    .timeTabBox {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 16px;

      .time {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        margin-right: 12px;
        @include multiline(1);
        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
      .tabBox {
        display: flex;
        .tab {
          padding: 0 4px;
          height: 16px;
          border-radius: 3px;
          margin-right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          @include useTheme {
            border: 1px solid getVar('primary-color');
          }
          &:last-child {
            margin-right: 0;
          }
          .tabFont {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            @include multiline(1);
            @include useTheme {
              color: getVar('primary-color');
            }
          }
        }
      }
    }
    .imgHtmlBox {
      display: flex;
      flex-direction: column;
      position: relative;
      .clickMore {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 160px;
        position: absolute;
        width: 100%;
        bottom: 0;
        @include useTheme {
          background: linear-gradient(
            180deg,
            getVar('bg-color7-1') 0%,
            getVar('bg-color7-2') 24%,
            getVar('bg-color7-3') 56%,
            getVar('bg-color-content') 100%,
            getVar('bg-color-content') 100%
          );
        }
        .morea {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          padding-right: 6px;
          cursor: pointer;
          @include useTheme {
            color: getVar('primary-color');
          }
        }
        .bottomIcon {
          width: 16px;
          height: 16px;
          cursor: pointer;
          @include useTheme {
            color: getVar('primary-color');
          }
        }
      }
    }
    .naturalBox {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-top: 4px;
      width: 100%;
      .natural {
        width: 100%;
        padding: 8px 16px 8px 12px;
        height: 52px;
        border-radius: 10px;
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include useTheme {
          border: 1px solid getVar('border-color2-f2f4f6');
          background: getVar('bg-color8-f9f9f9');
        }
        &:last-child {
          margin-bottom: 0;
        }
        .leftBox {
          display: flex;
          align-items: center;
          .leftIcon {
            width: 24px;
            height: 24px;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .rightInfo {
            margin-left: 12px;
            .text1 {
              max-width: 382px;
              font-weight: 600;
              font-size: 12px;
              line-height: 18px;
              @include multiline(1);
              @include useTheme {
                color: getVar('text-color1-2c2c2c');
              }
            }
            .text2 {
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              @include multiline(1);
              @include useTheme {
                color: getVar('text-color3-90969c');
              }
            }
          }
        }
        .rightBt {
          min-width: 94px;
          max-width: 94px;
          height: 28px;
          border-radius: 18px;
          font-weight: 500;
          font-size: 12px;
          color: #ffffff;
          line-height: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-left: 32px;
        }
      }
    }
    .checkBox {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      .cBox {
        display: flex;
        align-items: center;
        cursor: pointer;
        .checkIcon {
          width: 14px;
          height: 14px;
          @include useTheme {
            color: getVar('border-color4-e5e5e5');
          }
        }
        .checkIcon2 {
          @include useTheme {
            color: getVar('primary-color') !important;
          }
        }
        .checkFont {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          margin-left: 9px;
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
      }
    }
    .imgBox {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      .loadFail {
        max-width: 100%;
        width: 100% !important;
        height: 196px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        @include useTheme {
          background: getVar('bg-color10-f4f6f8');
        }
        .failIcon {
          width: 64px;
          height: 64px;
        }
      }
      .img {
        width: 100%;
        max-width: 100%;
        height: auto;
        border-radius: 16px;
        margin-bottom: 16px;
      }
    }
  }
  .comment {
    padding: 20px 0;
    flex-grow: 1;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    .commentHead {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      margin-bottom: 24px;
      white-space: nowrap;
      .headLeft {
        display: flex;
        justify-content: center;
        align-items: center;
        .cfont1 {
          font-weight: 600;
          font-size: 14px;
          line-height: 22px;
          margin-right: 8px;
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
        .cfont2 {
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .headRight {
        display: flex;
        align-items: center;
        ::v-deep .click-pop {
          .click-pop-box {
            top: 40px !important;
          }
        }
        .oneRight {
          display: flex;
          align-items: center;
          cursor: pointer;
          .oneIcon {
            width: 16px;
            height: 16px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .oneIcon2 {
            @include useTheme {
              color: getVar('primary-color') !important;
            }
          }
          .cfont3 {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            margin-left: 4px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .cfont3A {
            @include useTheme {
              color: getVar('primary-color') !important;
            }
          }
        }
        .line {
          width: 1px;
          height: 12px;
          margin: 0 8px;
          @include useTheme {
            background: getVar('border-color2-f2f4f6');
          }
        }
        .twoRight {
          padding: 7px 20px;
          max-width: 88px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 18px;
          cursor: pointer;
          white-space: nowrap;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
          .twoIcon {
            width: 16px;
            height: 16px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .cfont3 {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            margin-left: 4px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          &:hover {
            @include useTheme {
              background: getVar('bg-color1-f4f6f8');
            }
          }
        }
      }
    }
    .commitInputBox {
      display: flex;
      align-items: flex-start;
      padding: 0 16px;
      // align-items: center;
      .leftInput {
        height: 48px;
        .headImg {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
      .Input {
        flex: 1;
        margin: 0 12px;
        position: relative;
        .inputIcon {
          width: 20px;
          height: 20px;
          position: absolute;
          left: 16px;
          top: 15px;
          @include useTheme {
            color: getVar('text-color6-b8bec4');
          }
        }
      }
      .rightInput {
        margin-top: 4px;
        padding: 8px 24px;
        height: 40px;
        border-radius: 20px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        flex-shrink: 0;
      }
    }
    .commitContent {
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      .commitBox {
        display: flex;
        flex-direction: column;
        padding: 8px 0;
        .vipImg {
          height: 14px;
          margin-left: 6px;
          flex-shrink: 0;
        }
        .authorTopBox {
          margin-left: 6px;
          border-radius: 13px;
          padding: 0 6px;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          flex-shrink: 0;
          color: #ffffff;
          @include useTheme {
            background: getVar('primary-color');
          }
        }
        .oneCommit {
          display: flex;
          flex-direction: column;
          padding: 8px 16px;
          .leftC {
            display: flex;
            align-items: flex-start;
          }
          .twoInput {
            padding-left: 56px;
          }
        }
        .twoCommit {
          display: flex;
          flex-direction: column;
        }
        .twoInput {
          display: flex;
          align-items: center;
          // padding-left: 72px;
          margin-top: 8px;
          .rightInput {
            margin-top: 4px;
            padding: 8px 24px;
            height: 40px;
            border-radius: 20px;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
            flex-shrink: 0;
            margin-left: 12px;
          }
        }
        .twoMore {
          margin-top: 4px;
          padding-left: 72px;
          white-space: nowrap;
          display: flex;
          justify-content: flex-start;
          .twoMoreFont {
            cursor: pointer;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            @include useTheme {
              color: getVar('primary-color');
            }
          }
        }
        .headImg {
          width: 48px;
          height: 48px;
          object-fit: cover;
          border-radius: 50%;
          cursor: pointer;
        }
        .rightCommit {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          margin-left: 12px;
          flex: 1;
          ::v-deep .click-pop {
            .click-pop-box {
              top: 28px !important;
            }
          }
          .commitFont1 {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 2px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            line-height: 22px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
            .fontLeft {
              display: flex;
              align-items: center;
              justify-content: center;
              .nickname {
                @include multiline(1);
              }
            }
          }
          .commitFont2 {
            max-width: 508px;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 10px;
            // @include multiline(1);
            word-wrap: break-word;
            word-break: normal;
            white-space: pre-line;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .commitFont3 {
            display: flex;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .commitFont4 {
            cursor: pointer;
            margin-left: 20px;
          }
        }
        .commitChild {
          display: flex;
          flex-direction: column;
          padding: 8px 16px 8px 72px;
          .leftC {
            display: flex;
            align-items: flex-start;
          }
          .childImg {
            width: 34px;
            height: 34px;
            object-fit: cover;
            border-radius: 50%;
            cursor: pointer;
          }
          .childCommitBox {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            margin-left: 12px;
            flex: 1;
            .commitB {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }
            .commitFont4 {
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
              margin-bottom: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              @include useTheme {
                color: getVar('text-color3-90969c');
              }
              .commitText {
                @include multiline(1);
              }
              .replyFont {
                font-weight: 400;
                font-size: 14px;
                line-height: 22px;
                margin: 0 6px;
                flex-shrink: 0;
                @include useTheme {
                  color: getVar('text-color1-2c2c2c');
                }
              }
            }
            .commitFont5 {
              font-weight: 400;
              font-size: 14px;
              line-height: 22px;
              margin-bottom: 10px;
              white-space: pre-line;
              @include useTheme {
                color: getVar('text-color1-2c2c2c');
              }
            }
            .commitFont6 {
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              @include useTheme {
                color: getVar('text-color3-90969c');
              }
            }
            .commitFont7 {
              margin-left: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .moreCommit {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 32px;
      .more {
        max-width: 320px;
        height: 40px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        flex: 1;
        cursor: pointer;
        @include useTheme {
          background: getVar('bg-color1-f4f6f8');
          color: getVar('text-color1-2c2c2c');
        }
      }
      .not {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        @include useTheme {
          color: getVar('text-color6-b8bec4');
        }
      }
    }
    .loadStatus {
      padding: 16px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .loadBox {
        display: flex;
        align-items: center;
        justify-content: center;
        .spinner {
          border: 3px solid rgba(5, 216, 196, 0.2);
          border-radius: 50%;
          width: 18px;
          height: 18px;
          animation: spin 1s linear infinite;
          margin-right: 10px;
          @include useTheme {
            border-top: 3px solid getVar('primary-color');
          }
        }
      }
      .not {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .commitBg {
      @include useTheme {
        background: getVar('bg-color9-e6fbf9');
      }
    }
    .noneData {
      padding-top: 72px;
      padding-bottom: 120px;
      height: auto !important;
    }
    .moreBox {
      cursor: pointer;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-left: 6px;
      @include useTheme {
        color: getVar('text-color7-90969c');
      }
      .more {
        width: 16px;
        height: 16px;
      }
      &:hover {
        @include useTheme {
          background: getVar('bg-color1-f4f6f8');
        }
      }
    }
  }
  ::v-deep .commitInput {
    margin-top: 4px;
    .el-textarea__inner {
      min-height: 40px; /* 设置最小高度 */
      max-height: 106px;
      border-radius: 20px;
      padding: 9px 16px 9px 16px !important;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      border: 1px solid transparent;
      white-space: pre-wrap;
      word-break: break-all;
      overflow-y: auto !important;
      // transition: padding-left 0.2s;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
        caret-color: getVar('primary-color');
        background: getVar('bg-color14-f4f6f8');
      }
      &::placeholder {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        @include useTheme {
          color: getVar('text-color6-b8bec4');
        }
      }
      &:hover {
        @include useTheme {
          border: 1px solid getVar('primary-color');
        }
      }
      &:focus {
        transition: padding-left 0.2s;
        padding-left: 16px;
        @include useTheme {
          outline: 2px solid getVar('primary-color4');
          border: 1px solid getVar('primary-color');
          background: getVar('bg-color-content');
        }
      }
    }
  }
  ::v-deep .textInput {
    .el-textarea__inner {
      padding: 9px 16px 9px 44px !important;
    }
  }
  .bottomBox {
    z-index: 100;
    padding: 6px 16px;
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;
    // max-width: 600px;
    width: 100%;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 142px;
      height: 52px;
      cursor: pointer;
      .icon {
        width: 20px;
        height: 20px;
        @include useTheme {
          color: getVar('text-color2-75787b');
        }
      }
      .icon2 {
        @include useTheme {
          color: getVar('primary-color') !important;
        }
      }
      .bottomFont {
        font-weight: 500;
        font-size: 13px;
        line-height: 18px;
        margin-left: 6px;
        @include multiline(1);
        @include useTheme {
          color: getVar('text-color2-75787b');
        }
      }
      .bottomFont2 {
        @include useTheme {
          color: getVar('primary-color');
        }
      }
    }
  }
  .imagePreview {
    position: fixed;
    top: 45px;
    left: 40px;
    z-index: 3000;
    background-color: #606266;
    opacity: 0.8;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    line-height: 18px;
    padding: 6px 12px;
    border-radius: 4px;
  }
  // 骨架屏样式
  .isDetailNot {
    display: flex;
    flex-direction: column;
    height: 100%;
    .skeleton-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-name {
      height: 20px;
      width: 75px;
      margin-bottom: 2px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-fans {
      width: 50px;
      height: 18px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-bt {
      width: 74px !important;
      height: 32px;
      border-radius: 18px;
      margin-right: 16px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-title {
      width: 50%;
      height: 26px;
      margin-bottom: 14px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-time {
      width: 10%;
      height: 18px;
      margin-right: 12px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-html {
      width: 100%;
      height: 500px;
      border-radius: 16px;
      margin-bottom: 16px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-leftIcon {
      width: 24px;
      height: 24px;
      border-radius: 5px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-text1 {
      max-width: 382px;
      min-width: 100px;
      height: 16px;
      margin-bottom: 4px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-text2 {
      max-width: 382px;
      min-width: 50px;
      height: 16px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-rightBt {
      min-width: 94px;
      max-width: 94px;
      height: 28px;
      border-radius: 18px;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-left: 32px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-cfont1 {
      width: 50px;
      height: 22px;
      margin-right: 8px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-headImg {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-Input {
      flex: 1;
      margin: 0 12px;
      margin-top: 4px;
      min-height: 40px;
      max-height: 106px;
      border-radius: 20px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-bt2 {
      margin-top: 4px;
      width: 80px;
      height: 40px;
      border-radius: 20px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-noneIcon {
      width: 100px;
      height: 100px;
      margin-bottom: 24px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      border-radius: 10px;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-font2 {
      width: 80px;
      height: 22px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    @keyframes pulse {
      0%,
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0.8;
      }
    }
  }
}
</style>
